import VideoUploader from './VideoUploader';

export default VideoUploader;
